/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Calendar from './Calendar/index'
import CollapsibleSidebar from './CollapsibleSidebar/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content",
  containerRef,
  sidebarTopSpace,
  sidebarHeight,
  innerRef
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let tabAppointmentOverlayIsLocationChangingValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'appointment_overlay.is_location_changing',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 ref={containerRef}
 style={{'--bblr-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-Z1Yf8zk': dtColorsWhite,'--bc-6-Z1Yf8zk': dtColorsNeutral400}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={tabAppointmentOverlayIsLocationChangingValueData}>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
/>
</fromFlow.When>
<CollapsibleSidebar
  viewPath={`${viewPath}/CollapsibleSidebar`}
 sidebarTopSpace={sidebarTopSpace}
 sidebarHeight={sidebarHeight}
 containerRef={containerRef}
/>
<Calendar
  viewPath={`${viewPath}/Calendar`}
 innerRef={innerRef}
/>
</div>
{children}
</React.Fragment>)
}